module.exports = __webpack_public_path__ + "static/media/primevideo.9dcee33a.jpg";